import React, { ReactNode, ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useLocalStorage } from "../auth/useLocalStorage";

interface IUser {
  token?: string;
  userId?: string;
  userName?: string;
  login?: any;
  logout?: any;
}

interface IProps {
  children: ReactNode;
}

const baseUser: IUser = {};

export default function PrivateRoute({
  children,
}: IProps): ReactElement | null {
  const [user] = useLocalStorage("user", baseUser);
  const isLoggedIn = !!user?.token;

  if (isLoggedIn) {
    return <>{children}</>;  // Wrap children in a fragment to ensure it's a valid JSX element
  }
  
  return <Navigate to="/login" replace />;
}
